import { isCsr } from '@fe/armor_utils';
import Slardar from '@slardar/sdk-lite';
import { getAppInfo } from './bridge';
import { isInApp } from './utils';
export function captureMessage(error: Error) {
  Slardar.captureException && Slardar.captureException(error);
}
export function emitCounter(eventName: string, _value = 1, tags?: {
  [key: string]: string;
}) {
  Slardar.sendEvent?.({
    name: eventName,
    categories: tags
  });
}
export function emitCustom(eventName: string, metrics: {
  [key: string]: number;
}, tags?: {
  [key: string]: string;
}) {
  Slardar.sendEvent?.({
    name: eventName,
    metrics,
    categories: tags
  });
}
export function emitLog(content: string, level: 'debug' | 'info' | 'warn' | 'error', extra?: {
  [key: string]: string;
}) {
  Slardar.sendLog?.({
    content,
    level,
    extra
  });
}
export const setSlardrUserId = (userId: string) => {
  Slardar.config({
    userId
  });
};

if (isCsr() && isInApp()) {
  getAppInfo().then(({
    device_id
  }) => {
    if (device_id) {
      Slardar.config({
        deviceId: device_id
      });
    }
  });
}

export default Slardar;